import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface RolesConfirmState {
  popupIsOpen: boolean;
  isLoading: boolean;
  usersWithCustomPerms?: number;
  usersWithDefaultPerms?: number;
  column?: 'sections' | 'pages' | 'permissions';
}

const initialState: RolesConfirmState = {
  popupIsOpen: false,
  isLoading: false,
};

export const rolesConfirmSlice = createSlice({
  name: 'roles-confirm',
  initialState,
  reducers: {
    handleConfirmPopup: (state, action: PayloadAction<boolean>) => {
      state.popupIsOpen = action.payload;
    },
    getUsersWithPerm: (state) => {
      state.isLoading = true;
    },
    getUsersWithPermSuccess: (
      state,
      action: PayloadAction<{
        custom: number;
        default: number;
      }>,
    ) => {
      state.isLoading = false;
      state.usersWithCustomPerms = action.payload.custom;
      state.usersWithDefaultPerms = action.payload.default;
    },
    resetConfirmState: (state) => {
      state.popupIsOpen = initialState.popupIsOpen;
      state.isLoading = initialState.isLoading;
      state.usersWithCustomPerms = undefined;
      state.usersWithDefaultPerms = undefined;
    },
  },
});

export const {
  getUsersWithPerm,
  getUsersWithPermSuccess,
  handleConfirmPopup,
  resetConfirmState,
} = rolesConfirmSlice.actions;

export default rolesConfirmSlice.reducer;
